import { render, staticRenderFns } from "./SuggestFriendCRMReports.vue?vue&type=template&id=3f4fad3e&scoped=true"
import script from "./SuggestFriendCRMReports.vue?vue&type=script&lang=js"
export * from "./SuggestFriendCRMReports.vue?vue&type=script&lang=js"
import style0 from "./SuggestFriendCRMReports.vue?vue&type=style&index=0&id=3f4fad3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4fad3e",
  null
  
)

export default component.exports